/*
 * initializes and returns global Log object
 */

import { ILogSink } from './interfaces'
import { Logger } from './logger'

const logSinks: ILogSink[] = []
export const log = new Logger(logSinks)
